import { API_COOP, API_URL } from "../ApiPaths";

/** TEAM */
export const getCoop = async () => {
  const res = await fetch(API_URL + API_COOP, {
    method: "GET",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
    },
  });
  if (!res.ok) {
    throw new Error("Network response was not ok");
  }
  return res.json();
};

export const addNewCoop = async (tmpNew: string) => {
  const res = await fetch(API_URL + API_COOP, {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ name: tmpNew }),
  });

  if (!res.ok) {
    throw new Error("Network response was not ok");
  }

  return res.json();
};

export const deleteCoop = async (id: string) => {
  const res = await fetch(`${API_URL}${API_COOP}/${id}`, {
    method: "DELETE",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
    },
  });

  if (!res.ok) {
    throw new Error("Network response was not ok");
  }
  return res.json();
};
